/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Dashboard_Current_FormInputs */

const en_ui_dashboard_current_form = /** @type {(inputs: Ui_Dashboard_Current_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Form`)
};

const de_ui_dashboard_current_form = /** @type {(inputs: Ui_Dashboard_Current_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Form`)
};

/**
* | output |
* | --- |
* | "Current Form" |
*
* @param {Ui_Dashboard_Current_FormInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_dashboard_current_form = /** @type {((inputs?: Ui_Dashboard_Current_FormInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Dashboard_Current_FormInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_dashboard_current_form(inputs)
	return de_ui_dashboard_current_form(inputs)
});